/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { get, find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestRetailerPlansIfNotRequested } from 'state/rental-plans/actions';
import { getAllRetailerRentalPlans, requestingRetailerRentalPlans } from 'state/rental-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { 
    getCurrentRetailerRentalId, 
    getCurrentRetailerRentalPlanId, 
    getCurrentRetailerRental, 
    requestingCurrentRetailerRental,
    hasScheduledChanges } from 'state/current-retailer-rental/selectors';
import { 
    requestCurrentRetailerRentalIfNotRequested, 
    requestCurrentRetailerRental } from 'state/current-retailer-rental/actions';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';
import { isMultiStore } from 'state/current-user/selectors'

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectRentalPlan = (props) => {
    const retailerRentalPlans = props.retailerRentalPlans;
    const [submitting, setSubmitting] = useState(false);
    const [values, setValues] = useState({});
    const [scheduledChanges, setScheduledChanges] = useState(null);

    const onChange = (value) => {

        if (!props.retailerRentalSubscriptionId) {
            return newPlanSubscription(value);
        }

        let plan = find(retailerRentalPlans, { id: value });
        let addon = resolveLicenseAddon(plan);

        confirmAlert({
            title: 'Subscribe to Rental',
            message: 'Select a Rental plan.',
            submitting,
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmNewPlanAlert
                    currentRetailerRental={props.currentRetailerRental}
                    subscriptionId={props.retailerRentalSubscriptionId}
                    newPlanId={plan.id}
                    plan={plan}
                    addon={addon}
                    onClose={onClose}
                    onSubmit={() => handleSubscribe(value)}
                />
            ),
        });
    };

    useEffect(() => {
        props.requestRetailerRentalPlans();
        props.requestAddons();
        props.requestCoupons();
        props.requestCurrentRetailerRental();
    }, []);

    const handleSubscribe = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.retailerRentalSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Rental subscription will be updated at the end of the current billing period.',
                ),
                
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(
                () => setSubmitting(false),
                page.redirect('/dashboard/rental')
            );
    };

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.retailerRentalSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Rental subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(
                () => setSubmitting(false),
                page.redirect('/dashboard/rental')
            );
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            close: () => {},
            success: () => {
                props.requestCurrentRetailerRental();
                props.successNotice('Your Rental subscription has been created.');
                page.redirect('/dashboard/rental');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        return null;
    };

    if (!scheduledChanges && props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {retailerRentalPlans.map((plan, i) => {
                       
                        return (
                                <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentRetailerRental && props.currentRetailerRental.status == 'cancelled')
                                        ? props.hasScheduledChanges? props.hasScheduledChanges : props.isMultiStore ? props.isMultiStore : plan.id == props.retailerRentalPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        retailerRentalPlans: getAllRetailerRentalPlans(state),
        addons: getAllAddons(state),
        //retailerRentalSubscriptionId: getCurrentRetailerRentalId(state),
        retailerRentalSubscriptionId: getCurrentRetailerRentalId(state),
        retailerRentalPlanId: getCurrentRetailerRentalPlanId(state),
        currentRetailerRental: getCurrentRetailerRental(state),
        currentUser: getCurrentUser(state),
        requesting: requestingCurrentRetailerRental(state),
        hasScheduledChanges: hasScheduledChanges(state),
        isMultiStore: isMultiStore(state),
    }),
    {
        requestRetailerRentalPlans: requestRetailerPlansIfNotRequested,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
        requestCurrentRetailerRental: requestCurrentRetailerRentalIfNotRequested,
    },
)(SelectRentalPlan);
